<template>
  <div id="app">
    <p class="news-title">智能匹配</p>
    <!-- 添加提示文字 -->
    <div class="match-tips">每日可匹配三次</div>
    <div>
      <div v-for="(item, index) in list" :key="index" icon="location-o" class="div-postion" @click="tiao(item.id)">
        <van-cell :border="false" size="large" @click="tiao(item.id)">
          <template #title>
            <span class="">{{item.ncnicknamenc}}</span>
            <van-tag type="danger" round color="#ff8080" size="medium">&nbsp;{{item.sextext}}&nbsp;&nbsp;{{item.birthday}}岁&nbsp;</van-tag>
          </template>
          <template #label>
            <span class="">{{item.xjdaddress}}</span>
          </template>
          <template #icon>
            <img :src="item.headimgurl" alt="" class="left-img">
          </template>
        </van-cell>
        <div style="background: #FFFFFF;width: 65%;">
          <div class="xl-sg-hyzk">学历：{{item.xlname}}&nbsp;&nbsp;身高：{{item.sgname}}cm&nbsp;&nbsp;</div>
          <div class="h-10"></div>
          <div class="xl-sg-hyzk">婚姻状况：{{item.hynametext}} <span style="float: right;color: #ee0a24;">太原鹊桥会员</span></div>
          <div class="h-10"></div>
          <div class="h-15 bj-f7f7f7"></div>
        </div>
        <img v-lazy="item.picurl" class="vant-lazy" />
      </div>
    </div>
	 <div v-if="maskLoading" class="loading-mask">
	      <van-loading type="spinner" color="#fff" size="40px" />
	    </div>
    <!-- 底部按钮 -->
    <div class="reload-btn" @click="handleReload">
      {{ reloading ? `匹配中(${countdown}s)` : '重新匹配' }}
    </div>
    <div class="h-50"></div>
  </div>
</template>

<script>
 export default {
   data () {
     return {
       list: [],
       reloading: false,
       countdown: 0,
       timer: null,
       maskLoading: false,
     }
   },
   methods: {
     recordapi(){
       var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       return that.$api.post("/Index/memberlist",{'userid':userid}).then(res => {
         console.log(res);
         if (res.code == 1) {
           that.list = res.list;
         } else {
           that.$toast(res.msg || '获取失败');
         }
       }).catch(err => {
         that.$toast('网络错误，请重试');
       });
     },
     handleReload(){
       if (this.reloading) return;
       this.maskLoading = true;
       const seconds = Math.floor(Math.random() * 4) + 2;
       this.reloading = true;
       this.countdown = seconds;
       this.timer = setInterval(() => {
         if (this.countdown <= 1) {
           clearInterval(this.timer);
           this.timer = null;
           this.reloading = false;
           this.countdown = 0;
           this.recordapi().finally(() => {
             this.maskLoading = false;
           });
         } else {
           this.countdown--;
         }
       }, 1000);
     },
     tiao(e){
       this.$router.push('Usercont?id='+e)
     },
   },
   beforeDestroy() {
     if (this.timer) clearInterval(this.timer);
   }
 }
</script>
<style>
	.loading-mask {
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  background: rgba(0,0,0,0.5);
	  z-index: 9999;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}

	
	.icon_img img{width: 40px;height: 40px;border-radius: 20px;}
	.icon_img .van-cell__left-icon{height: 40px !important;}
	
	.match-tips {
	  text-align: center;
	  font-size: 28rpx;
	  color: #999;
	  padding: 20rpx 0;
	}
	.reload-btn {
	  width: 60%;
	  margin: 30px auto;
	  background: #ee0a24;
	  color: #fff;
	  text-align: center;
	  line-height: 40px;
	  border-radius: 40px;
	  font-size: 18px;
	  cursor: pointer;
	}
	.reload-btn:active {
	  opacity: 0.8;
	}
	
	
</style>


// WEBPACK FOOTER //
// src/components/MemberList.vue